import * as React from "react";
import { makeStyles } from "@mui/styles";

import SearchIcon from "@mui/icons-material/Search";
import { Paper, InputBase, IconButton, Grid } from "@mui/material";

const useStyles = makeStyles({
  input: {
    "&::placeholder": {
      fontWeight: 400,
      fontsize: "14px",
      lineHeight: "20px",
      color: "#000000",
      mixBlendMode: "normal",
      opacity: "0.4",
    },
  },
});

export default function Search() {
  const classes = useStyles();

  return (
    <Grid item xs={3} paddingRight="22px" textAlign="end">
      <Paper
        component="form"
        elevation={0}
        sx={{
          p: "15px 18px",
          display: "flex",
          alignItems: "center",
          width: "inherit",
          height: "50px",
          borderRadius: "10px",
          justifyContent: "space-between",
        }}
      >
        <InputBase
          fullWidth
          inputProps={{
            className: classes.input,
          }}
          placeholder="Search"
        />
        <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
          <SearchIcon style={{ color: "#231F20" }} />
        </IconButton>
      </Paper>
    </Grid>
  );
}
